
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDocumentStateComponent } from './file-document-state.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MyMaterialModule } from 'src/app/app.material';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    FileDocumentStateComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MyMaterialModule,
    MatIconModule,
    TranslocoModule
  ],
  exports: [FileDocumentStateComponent]
})
export class FileDocumentStateModule { }
